/**
 * A frase da tela para cada recusa da raia eletrônica (extraído da
 * `PreAnaliseEletronicaPage` na E89.F2.C01, que a levou acima do teto de linhas).
 *
 * É dado, não comportamento: um `Record` sobre o union dos motivos, e o
 * `tsc` recusa motivo novo sem frase — a paridade do catálogo é do tipo.
 */
import { ptBR } from '@/i18n/pt-BR';
import { ExameEletronicoError, type ExameEletronicoErrorReason } from '@/lib/exame_eletronico';

const t = ptBR.exameEletronico;
const ti = ptBR.exameEletronico.importarProtocolo;
const tc = ptBR.exameEletronico.conferenciaFacial;

const _ERROR_MESSAGE: Record<ExameEletronicoErrorReason, string> = {
  case_not_found: t.errorCaseNotFound,
  document_not_found: t.errorDocumentNotFound,
  not_found: t.errorNotFound,
  modalidade_invalida: t.errorModalidadeInvalida,
  sem_protocolo: t.errorSemProtocolo,
  nao_verificado: t.errorNaoVerificado,
  justificativa_requerida: t.errorJustificativaRequerida,
  concluido: t.errorConcluido,
  consulta_pendente: t.errorConsultaPendente,
  nao_concluido: t.errorNaoConcluido,
  certificacao_requerida: t.errorCertificacaoRequerida,
  protocolo_peca_concluida: t.errorProtocoloPecaConcluida,
  custodia_interrompida: t.errorCustodiaInterrompida,
  aguardando_arquivos: t.errorAguardandoArquivos,
  protocolo_nao_importado: ti.erros.protocolo_nao_importado,
  documento_ilegivel: ti.erros.documento_ilegivel,
  documento_sem_texto: ti.erros.documento_sem_texto,
  arquivo_nao_suportado: ti.erros.arquivo_nao_suportado,
  arquivo_vazio: ti.erros.arquivo_vazio,
  arquivo_muito_grande: ti.erros.arquivo_muito_grande,
  arquivo_nao_e_imagem: ptBR.exameEletronico.fotosDoSignatario.erros.arquivo_nao_e_imagem,
  // E80.F2 — as recusas da conferência facial. Vivem no mesmo vocabulário de
  // erro da raia eletrônica: um segundo classificador só para elas duplicaria a
  // leitura da resposta do servidor para ganhar cinco chaves.
  foto_integridade: tc.erros.foto_integridade,
  foto_indisponivel: tc.erros.foto_indisponivel,
  conferencia_sem_par: tc.erros.conferencia_sem_par,
  conferencia_em_andamento: tc.erros.conferencia_em_andamento,
  conferencia_indisponivel: tc.erros.conferencia_indisponivel,
  provider_auth: tc.erros.provider_auth,
  provider_credit: tc.erros.provider_credit,
  sem_chave: tc.erros.sem_chave,
  // E87.F2: a etapa da análise fotográfica é outra tela; a chave existe aqui
  // porque o classificador de erro da raia é um só.
  candidata_nao_encontrada: ptBR.analiseFotografica.candidatas.erros.candidata_nao_encontrada,
  candidata_ja_confirmada: ptBR.analiseFotografica.candidatas.erros.candidata_ja_confirmada,
  validation: t.errorValidation,
  forbidden: t.errorForbidden,
  network: t.errorNetwork,
  unknown: t.errorGeneric,
};

export function messageFor(err: unknown): string {
  if (err instanceof ExameEletronicoError) return _ERROR_MESSAGE[err.reason];
  return t.errorGeneric;
}
